<template>
    <div class="Search-hot-word">
        <van-nav-bar left-text="搜索热词" left-arrow @click-left="$router.go(-1)" />
        <ul>
            <li v-for="(item, index) in hotWordList" :key="index">
                <span>{{ index+1 }}</span>
                <span>{{ item.word }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hotWordList: null
        };
    },
    beforeRouteEnter(to, from, next) {
        // ...
        next(vm => {
            vm.axios.get("https://novel.kele8.cn/search-hotwords").then(response => {
                // window.console.log(response.data);
                ({ searchHotWords: vm.hotWordList } = response.data);
                localStorage.setItem(
                    "hotWordList",
                    JSON.stringify({
                        time: Date.now(),
                        data: vm.hotWordList
                    })
                );
            });
        });
    }
};
</script>

<style lang="less" scope>
.Search-hot-word {
    
    .van-nav-bar {
        // color: rgb(184, 51, 32);
        .van-nav-bar__left {
            left: 0;
            .van-nav-bar__text {
                color: rgb(184, 51, 32);
                font-size: 16px;
            }
            .van-icon {
                font-size: 24px;
                color: rgb(184, 51, 32);
            }
        }
    }
    ul{
        padding: 0 15px;
        li{
            border-bottom: 1px solid rgb(246, 245, 245);
            padding: 10px 0;
            display: flex;
            span{
                font-size: 18px;
                &:first-child{
                width: 30px;  
                font-weight: 500;
                }
                &:last-child{
                    flex: 1;
                }
            }
        }
    }
}
</style>
